import { render, staticRenderFns } from "./ClipboardQuickInsertPopover.vue?vue&type=template&id=40df1670&scoped=true"
import script from "./ClipboardQuickInsertPopover.vue?vue&type=script&lang=js"
export * from "./ClipboardQuickInsertPopover.vue?vue&type=script&lang=js"
import style0 from "./ClipboardQuickInsertPopover.vue?vue&type=style&index=0&id=40df1670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df1670",
  null
  
)

export default component.exports